import { useNavigate } from "react-router-dom";
import AppBar from "../../components/atoms/appbar";
import { vw } from "../../lib/utils/responsiveUtils";
import { useQuery } from "@tanstack/react-query";
import { useNoticeList } from "../../@apis/hooks/useCommunity";
import { staticURL } from "../../lib/utils/imageUtils";
import { useMainGolfParkDetail } from "../../@apis/hooks/useMain";
import React from "react";

export default function Notice() {
  const navigate = useNavigate();

  // store
  const store = new URLSearchParams(location.search).get("store");

  // 현재 골프장 정보
  const { data: storeData, isSuccess: storeSuccess } = useQuery({
    ...useMainGolfParkDetail(store || ""),
    enabled: !!store,
  });
  const { golfPark } = storeData?.data || {};

  // 공지 리스트: store가 있으면 해당 골프장만, 없으면 전체
  const noticeForm = React.useMemo(
    () => ({
      pageSize: 10,
      golfParkCodeList: store ? store : undefined,
    }),
    [store],
  );

  const { data } = useQuery({ ...useNoticeList(noticeForm) });
  const notices = data?.data.noticeList ?? [];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <AppBar backButton title="공지사항" />

      {/* 리스트 영역 */}
      <section className="px-[15px] space-y-[12px]">
        {!!store && storeSuccess && (
          <div className="bg-[#f5f5f5] px-[20px] py-[14px] rounded-[15px] gap-x-[20px] mb-[15px] flex mt-[10px]">
            {golfPark?.imageUrl ? (
              <img
                src={staticURL(golfPark.imageUrl)}
                alt="_blank"
                className="rounded-[10px] shrink-0 mt-[6px]"
                style={{ width: vw(83), height: vw(83) }}
              />
            ) : (
              <img
                src="/images/img-login-logo.webp"
                alt="_blank"
                className="rounded-[10px] shrink-0 mt-[6px]"
                style={{ width: vw(83), height: vw(83) }}
              />
            )}
            <div>
              <p className="font-bold text-2xl">{golfPark?.name}</p>
              <div className="flex gap-[5px] items-start mt-[14px] font-[500] text-[#888] text-sm ">
                <img
                  className="size-[0.9rem] mt-[4px]"
                  src="/icons/ic-place-gray.webp"
                />
                <p className="whitespace-pre-line break-keep break-words">
                  {golfPark?.address}
                </p>
              </div>
            </div>
          </div>
        )}

        {notices.length === 0 ? (
          <div className="flex-row w-full font-[500] text-[#ccc] text-center">
            <span className="w-full text-sm">등록된 공지사항이 없습니다.</span>
          </div>
        ) : (
          notices.map((item) => {
            const hasThumb = item.fileList?.length > 0;

            return (
              <div
                key={item.id}
                onClick={() => navigate(`/notice/${item.id}`)}
                className={`relative flex bg-[#f5f5f5] rounded-[15px] px-[20px] py-[15px] mb-[15px] cursor-pointer ${
                  hasThumb ? "gap-[37px]" : "gap-[0px]"
                }`}
              >
                {/* 왼쪽: 텍스트 블럭 */}
                <div className="min-w-0">
                  <p className=" font-[500] text-[#222] leading-[150%] truncate">
                    {item.title}
                  </p>
                  <p className=" font-[500] text-[#888] whitespace-pre-line line-clamp-3 text-sm leading-[150%]">
                    {item.content}
                  </p>
                </div>

                {/* 오른쪽: 썸네일 */}
                {hasThumb && (
                  <div
                    className="rounded-[10px] overflow-hidden"
                    style={{ width: vw(69), height: vw(69) }}
                  >
                    <img
                      src={
                        staticURL
                          ? staticURL(item.fileList[0].fileUrl)
                          : item.fileList[0].fileUrl
                      }
                      alt="공지 이미지"
                      className="rounded-[10px] shrink-0 mt-[5px] object-cover"
                      style={{ width: vw(78), height: vw(78) }}
                    />
                  </div>
                )}
              </div>
            );
          })
        )}
      </section>
    </div>
  );
}
